import clsx from 'clsx';
import * as React from 'react';
import styled from 'styled-components';

type Props = {
  label: string;
  name: string;
  value: string;
  disabled?: boolean;
  fontSize: string;
} & React.InputHTMLAttributes<HTMLLabelElement>;
export const Radio = ({
  fontSize,
  name,
  value,
  disabled,
  label,
  ...props
}: Props & React.InputHTMLAttributes<HTMLLabelElement>) => {
  return (
    <Label $size={fontSize} {...props} className={clsx({ disabled })}>
      <input type="radio" name={name} value={value} disabled={disabled} />
      <span>{label}</span>
    </Label>
  );
};

const Label = styled.label<{ $size: string }>`
  display: flex;
  align-items: center;
  font-size: ${({ $size }) => $size};

  & > span {
    padding-left: 0.6rem;
  }
  & > input {
    width: ${({ $size }) => $size};
    height: ${({ $size }) => $size};
  }

  &.disabled > span {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
